<template>
    <div class="auth-wrapper auth-v2">
        <div class="auth-inner row m-0">
            <!-- Brand logo-->
            <a class="brand-logo" href="/">
                <img src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/Marketing/creditfixrr-best-credit-repair-software-logo.png" alt="creditfixrr logo" style="width:180px;">
            </a>
            <!-- /Brand logo-->
            <!-- Left Text-->
            <div class="d-none d-lg-flex col-lg-8 align-items-center p-5">
                <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
                    <img class="img-fluid" src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/Marketing/Computer%20login-rafiki.svg" alt="Login V2" style="width:80%"/>
                </div>
            </div>
            <!-- /Left Text-->
            <!-- Login-->
            <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5">
                <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
                    <h2 class="card-title font-weight-bold mb-1">You Are The Creditfixrr 💪</h2>
                    <p class="card-text mb-2">Please sign-in to your account.</p>
                    <form class="auth-login-form mt-2">
                        <div class="form-group">
                            <label class="form-label" for="login-email">Email</label>
                            <input
                                class="form-control"
                                id="login-email"
                                type="text"
                                name="login_email"
                                placeholder="example@email.com"
                                aria-describedby="login-email"
                                v-model="state.email"
                            />
                            <div v-if="vuelidate.email.$error" class="error mt-1">Email {{vuelidate.email.$errors[0].$message.toLowerCase()}}</div>
                            <ErrorHandler :error="userStore.error" keyword="email"/>
                        </div>
                        <div class="form-group">
                            <div class="d-flex justify-content-between">
                                <label for="login-password">Password</label>
                                <a :href="$router.resolve({ name: 'reset-password'}).href">
                                    <small>Forgot Password?</small>
                                </a>
                            </div>
                            <div class="input-group input-group-merge form-password-toggle">
                                <input
                                    class="form-control form-control-merge"
                                    id="login-password"
                                    type="password"
                                    name="login-password"
                                    placeholder="············"
                                    v-model="state.password"
                                    @keyup.enter="login($event)"
                                />
                                <div class="input-group-append">
                                    <span class="input-group-text cursor-pointer">
                                        <vue-feather type="eye" size="12" />
                                    </span>
                                </div>
                            </div>
                            <div v-if="vuelidate.password.$error" class="error mt-1">Password {{vuelidate.password.$errors[0].$message.toLowerCase()}}</div>
                            <ErrorHandler :error="userStore.error" keyword="password"/>
                        </div>
                        <div class="form-group">
                            <div class="custom-control custom-checkbox">
                                <input class="custom-control-input" id="remember-me" type="checkbox" tabindex="3" v-model="userStore.remember"/>
                                <label class="custom-control-label" for="remember-me"> Remember Me</label>
                            </div>
                        </div>
                        <div v-if="userStore.errorMessage" class="error mb-1">{{ userStore.errorMessage }}</div>
                        <button type="button" class="btn btn-primary btn-block" tabindex="4" @click="login($event)" v-if="userStore.authenticating" disabled>{{ userStore.loginUser }}</button>
                        <button type="button" class="btn btn-primary btn-block" tabindex="4" @click="login($event)" v-else>{{ userStore.loginUser }}</button>
                    </form>
                    <p class="text-center mt-2">
                        <span>New on our platform?</span>
                        <router-link :to="{ name: 'register' }">
                            <span>&nbsp;Create an account</span>
                        </router-link>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ref, reactive } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { required, email, maxLength, minLength, } from '@vuelidate/validators'
import {useUserStore} from '../../stores/UserStore.js'

import ErrorHandler from "./ErrorComponent.vue"

import axios from 'axios'

export default {
    name: 'LoginPageComponent',
    components:{
        ErrorHandler
    },
    setup () {
        const rules = {
            email: {
                required,
                email
            },
            password: {
                required,
                minLength: minLength(8),
                maxLength: maxLength(24)
            }
        };
        const state = reactive({
            email: null,
            password: null,
        });
        return {
            state,
            userStore:useUserStore(),
            vuelidate: useVuelidate(rules, state)
        }
    },
    created(){
    },
    methods:{
        login(e){
            e.preventDefault();
            this.vuelidate.$validate();
            if(this.vuelidate.$errors.length <= 0){
                this.userStore.authenticating =true;
                this.userStore.loginUser = 'Authenticating...'
                this.userStore.disabled = 'disable'
                let authState = {
                    email : this.state.email.toLocaleLowerCase(),
                    password : this.state.password,
                    remember : this.userStore.remember,
                }
                let route = this.$router.resolve({ 
                    name: 'login'
                });
                axios.post(route.href,authState).then(({data})=>{
                    if(data.data.authenticated == true){
                        this.userStore.loginUser = 'Authenticated'
                        setTimeout(() => {
                            window.location.href=data.data.route
                        }, 1000);
                    }else{
                        this.userStore.loginUser = 'Sign In'
                        this.userStore.authenticating =false;
                        this.userStore.errorMessage = data.data.message;
                        this.userStore.disabled = ''
                    }
                }).catch((error) => {
                    this.userStore.error = this.getError(error)
                    this.userStore.loginUser = 'Sign In'
                    this.userStore.authenticating =false;
                    return false;
                });
            }else{
                return false
            }
        },
        getError(error){
            const errorMsg = "";
            if (!error.response) {
                return errorMsg;
            }
            if (error.response.data && error.response.data.errors) {
                return error.response.data.errors;
            }
            return errorMsg;
        }
    }
}
</script>
<style lang="scss">
    @import '~/css/base/pages/page-auth.css';
</style>